/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { paymentControllerFindById } from '../fn/payment/payment-controller-find-by-id';
import { PaymentControllerFindById$Params } from '../fn/payment/payment-controller-find-by-id';
import { paymentControllerRefund } from '../fn/payment/payment-controller-refund';
import { PaymentControllerRefund$Params } from '../fn/payment/payment-controller-refund';
import { paymentControllerSearch } from '../fn/payment/payment-controller-search';
import { PaymentControllerSearch$Params } from '../fn/payment/payment-controller-search';
import { PaymentDto } from '../models/payment-dto';

@Injectable({ providedIn: 'root' })
export class PaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `paymentControllerSearch()` */
  static readonly PaymentControllerSearchPath = '/api/payment';

  /**
   * 결제 목록 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentControllerSearch$Response(params: PaymentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return paymentControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 결제 목록 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentControllerSearch(params: PaymentControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.paymentControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `paymentControllerFindById()` */
  static readonly PaymentControllerFindByIdPath = '/api/payment/{id}';

  /**
   * 결제 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentControllerFindById$Response(params: PaymentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentDto>> {
    return paymentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 결제 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentControllerFindById(params: PaymentControllerFindById$Params, context?: HttpContext): Observable<PaymentDto> {
    return this.paymentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentDto>): PaymentDto => r.body)
    );
  }

  /** Path part for operation `paymentControllerRefund()` */
  static readonly PaymentControllerRefundPath = '/api/payment/{id}/refund';

  /**
   * 결제 환불 처리.
   *
   * 토스로 결제하지 않은 건만 환불 처리합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentControllerRefund()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentControllerRefund$Response(params: PaymentControllerRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentDto>> {
    return paymentControllerRefund(this.http, this.rootUrl, params, context);
  }

  /**
   * 결제 환불 처리.
   *
   * 토스로 결제하지 않은 건만 환불 처리합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentControllerRefund$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentControllerRefund(params: PaymentControllerRefund$Params, context?: HttpContext): Observable<PaymentDto> {
    return this.paymentControllerRefund$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentDto>): PaymentDto => r.body)
    );
  }

}
